import axios, { AxiosError } from 'axios';

export  function  setupAPIclient(token?: string) {
    
    const api = 
    axios.create({
        baseURL: 'https://alexios.com.br:9598',
        timeout: 8000

    }) 
    api.interceptors.response.use(
        response => response,
        (error: AxiosError) => {
            console.error("Erro na requisição:", error.message);
            return 401; // Rejeita corretamente
        }
    );
    return api
}



